import React, {useEffect, useState} from "react";
import './ResetPasswordPage.scss';
import {useSearchParams} from "react-router-dom";
import BaseInput from "../../Components/BaseInput/BaseInput";
import BaseButton from "../../Components/BaseButton/BaseButton";
import Success from "../../Components/Success/Success";
import check from '../../Assets/Icons/check.svg'
import axios from "axios";
import {useLoader} from "../../hooks/useLoader";
import Loader from "../../Components/Loader/Loader";
import {useTranslation} from "react-i18next";

const ResetPasswordPage: React.FC = () => {
    const {t} = useTranslation('resetPassword')
    const [searchParams, ] = useSearchParams();
    const email = searchParams.get("t")
    const id = searchParams.get("s")
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const [mdp1, setMdp1] = useState<string>('')
    const [mdp2, setMdp2] = useState<string>('')
    const [mdp2Error, setMdp2Error] = useState<string>('')

    const loader = useLoader()

    useEffect(() => {
        if (mdp1 !== mdp2) {
            setMdp2Error(t('errors.mismatch'))
        } else {
            setMdp2Error('')
        }
    }, [mdp1, mdp2, t])

    const sendResetPasswordEmail = () => {
        if (mdp1.length >= 6 && mdp2.length > 0 && mdp2Error.length === 0) {
            loader.show()
            axios.put(`${process.env.REACT_APP_BART_URL}/users/${id}/updateMdp`, {id: id, newMdp: mdp1})
                .then(function () {
                    loader.hide()
                    setShowSuccess(true)
                })
                .catch(function () {
                    loader.hide()
                });
        } else {
            if (mdp1.length === 0) {
            } else if (mdp1 !== mdp2 || mdp1.length < 6) {
            }
        }
    }

    return (
        <>
            <div className="resetPassword">
                <p className="resetPassword--title">{t('title')}</p>
                <p className="resetPassword--text">{t('emailPrompt', {email})}</p>
                <BaseInput
                    title={t('newPasswordLabel')}
                    helpTxt={t('passwordHelp')}
                    onChange={setMdp1}
                    value={mdp1}
                    type={"password"}
                    className="resetPassword--input"
                />
                <BaseInput
                    title={t('repeatPasswordLabel')}
                    onChange={setMdp2}
                    errorTxt={mdp2Error}
                    value={mdp2}
                    type={"password"}
                    className="resetPassword--input"
                />
                <BaseButton text={t('submit')}
                            onClick={() => sendResetPasswordEmail()} type={'filled'} className="resetPassword--btn"/>
            </div>
            <Success
                show={showSuccess}
                title={t('successTitle')}
                subTitle={t('successSubtitle')}
                icone={check}
            />
            <Loader visible={loader.visible} />
        </>
    )
}

export default ResetPasswordPage
